import { create } from "zustand";

const AuthStore = create((set) => ({
    user: null, // Add user data to the store
    setUser: (user) => set({ user }), // Action to set user data
    clearUser: () => set({ user: null }), // Action to clear user data
  }));
  
  export default AuthStore;